import { createContext } from 'react';
import { Goal } from 'shared/types/goal';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

export type CreateGoalOptions = Partial<Goal> & {
  skipNavigation?: boolean;
  tasks?: Task[];
};

export type GoalFormContextProps = {
  onCreateGoal: (options?: CreateGoalOptions) => void;
  onEditGoal: (initialValues: Partial<Goal>, id: ID) => void;
};

export const GoalFormContext = createContext<GoalFormContextProps>({
  onCreateGoal: () => {},
  onEditGoal: () => {},
});
